<h2 mat-dialog-title>
  Delete Template</h2>
<mat-dialog-content class="flex flex-col">
  <span class="mb-4">{{deleteMessage}}</span>
</mat-dialog-content>
<div mat-dialog-actions *ngIf="canDelete;else cantDelete" class="flex flex-row place-content-end items-end -mr-2 pb-2">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="warn" [mat-dialog-close]="true">Delete</button>
</div>
<ng-template #cantDelete>
  <div mat-dialog-actions class="flex flex-row place-content-end items-end -mr-2 pb-2">
    <button mat-button color="primary" [mat-dialog-close]="false">Ok</button>
  </div>
</ng-template>